(function() {
  function makeSlideClickable() {
    const slideshow = document.querySelector('.slideshow');
    if (!slideshow) return;
    
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    
    slides.forEach(function(slide) {
      const button = slide.querySelector('.button, .banner__button, [class*="button"]');
      
      if (button && button.href) {
        slide.style.cursor = 'pointer';
        
        slide.addEventListener('click', function(event) {
          // Don't redirect if clicking on the button itself
          if (event.target.closest('.button, .banner__button, [class*="button"]')) {
            return;
          }
          
          event.preventDefault();
          window.location.href = button.href;
        });
      }
    });
  }
  
  // Run when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', makeSlideClickable);
  } else {
    makeSlideClickable();
  }
})();
